import React from 'react';
import {connect} from 'react-redux';
import LeadGenFieldCreateButton from 'components/forms/CustomFields/LeadGenFieldCreateButton';
import {startLeadGenFieldPickAction} from "pages/LeadGenFieldPicker/actions";

const mapDispatchToProps = (dispatch) => ({
    createClicked: (brk, leadGen, fieldPath, resourcePath) => dispatch(startLeadGenFieldPickAction(brk, leadGen, fieldPath, resourcePath))
});

export default connect(null, mapDispatchToProps)(LeadGenFieldCreateButton)



// WEBPACK FOOTER //
// ./public/components/composites/LeadGenFieldCreateButtonConnected.jsx